/**
 * Labstep
 *
 * @module grid/SmartTableProtocolValue/components/ColumnHeader/BulkCreateResourceItemTrigger
 * @desc Default DataGrid ColumnHeader
 */

import classnames from 'classnames';
import { ProtocolValueActionBulkCreateItems } from 'labstep-web/components/ProtocolValue/Action/BulkCreateItems';
import { ProtocolValueActionBulkUpdateAmounts } from 'labstep-web/components/ProtocolValue/Action/BulkUpdateAmounts';
import { EntityReadEntityContainer } from 'labstep-web/containers/Entity/Read/Entity';
import { useGridSmartTableProtocolValueServiceFromContext } from 'labstep-web/contexts/grid/hook';
import { Flex } from 'labstep-web/core/Flex';
import { Icon } from 'labstep-web/core/Icon';
import { ProtocolValue } from 'labstep-web/models/protocol-value.model';
import type React from 'react';
import { useRef } from 'react';
import styles from './styles.module.scss';
import type { GridSmartTableColumnHeaderBulkCreateResourceItemTriggerProps } from './types';

export const GridSmartTableColumnHeaderBulkCreateResourceItemTrigger: React.FC<
  GridSmartTableColumnHeaderBulkCreateResourceItemTriggerProps
> = (props) => {
  const {
    onClick,
    displayName,
    icon,
    cornerIcon,
    action,
    column,
    secondaryHeader,
    experimentId,
    protocolValueName,
    variableTemplateGuid,
    protocolValue,
    colDefId,
  } = props;
  const ref = useRef<HTMLDivElement | null>(null);

  const gridSmartTableProtocolValueService =
    useGridSmartTableProtocolValueServiceFromContext();

  const protocolValues =
    (protocolValueName &&
      gridSmartTableProtocolValueService?.getProtocolValues(
        protocolValueName,
      )) ||
    [];

  return (
    <div
      ref={ref}
      className={classnames(styles.defaultContainer, {
        [styles.clickable]: !!onClick,
      })}
    >
      <div className={styles.title} ref={ref} onClick={onClick}>
        {icon && <Icon name={icon} cornerIcon={cornerIcon} />}{' '}
        <Flex column>
          {displayName}
          {secondaryHeader && (
            <span className={styles.secondaryHeader}>
              {secondaryHeader}
            </span>
          )}
        </Flex>
      </div>
      {!variableTemplateGuid && protocolValues.length > 0 && (
        <ProtocolValueActionBulkUpdateAmounts
          protocolValues={protocolValues}
          onSuccess={() => {
            setTimeout(() => {
              gridSmartTableProtocolValueService?.agGrid.api.refreshCells(
                {
                  columns: [column.getId()],
                  force: true,
                  suppressFlash: true,
                },
              );
            }, 50);
          }}
        />
      )}
      {variableTemplateGuid && (
        <EntityReadEntityContainer
          entityName={ProtocolValue.entityName}
          id={variableTemplateGuid}
        >
          {({ entity }) => {
            return null;
            // if (entity && entity.is_input) {
            //   return (
            //     <ProtocolValueActionBulkUpdateAmounts
            //       protocolValues={protocolValues}
            //       onSuccess={() => {
            //         setTimeout(() => {
            //           gridSmartTableProtocolValueService?.agGrid.api.refreshCells(
            //             {
            //               columns: [column.getId()],
            //               force: true,
            //               suppressFlash: true,
            //             },
            //           );
            //         }, 50);
            //       }}
            //     />
            //   );
            // }

            // return (
            //   entity &&
            //   !entity.is_input &&
            //   experimentId && (
            //     <ProtocolValueActionBulkCreateItems
            //       variableTemplate={entity}
            //       getProtocolValues={() => {
            //         return (
            //           gridSmartTableProtocolValueService?.getProtocolValues() ||
            //           []
            //         );
            //       }}
            //       experimentId={experimentId}
            //       colDefId={colDefId}
            //     />
            //   )
            // );
          }}
        </EntityReadEntityContainer>
      )}

      {action}
    </div>
  );
};
